"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _copyToClipboard = _interopRequireDefault(require("copy-to-clipboard"));

var _Button = _interopRequireDefault(require("./Button"));

var _Snackbar = _interopRequireDefault(require("./Snackbar"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CopyButton = function CopyButton(props) {
  var value = props.value,
      successMessage = props.successMessage,
      _onClick = props.onClick,
      rest = (0, _objectWithoutProperties2["default"])(props, ["value", "successMessage", "onClick"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      copied = _useState2[0],
      setCopied = _useState2[1];

  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_Snackbar["default"], {
    show: copied,
    delay: 2000,
    onHideSnackbar: function onHideSnackbar() {
      return setCopied(false);
    }
  }, successMessage), _react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, rest, {
    onClick: function onClick(e) {
      (0, _copyToClipboard["default"])(value);
      setCopied(true);

      if (_onClick) {
        _onClick(e);
      }
    }
  }), props.children || 'Copy'));
};

CopyButton.propTypes = _objectSpread({
  value: _propTypes["default"].string,
  successMessage: _propTypes["default"].string
}, _Button["default"].propTypes);
CopyButton.defaultProps = {
  successMessage: 'Copied successfully.'
};
var _default = CopyButton;
exports["default"] = _default;